import validate from "/home/bun/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/bun/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "sidebase-auth": () => import("/home/bun/app/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}